import { useState, useEffect } from 'react';
import { UserDropDownOption } from 'src/types';
import { useUserService } from 'src/context';

const useUserDropDown = () => {
  const userService = useUserService();
  const [userDropDownOptions, setUserDropDownOptions] =
    useState<UserDropDownOption[]>();

  useEffect(() => {
    const fetchUserDropDown = async () => {
      try {
        const userDropDownOptions = await userService.getUserDropDownOptions();
        setUserDropDownOptions(userDropDownOptions);
      } catch (err) {
        console.warn('Error fetching user data');
      }
    };

    fetchUserDropDown();
  }, [userService]);

  return { userDropDownOptions };
};

export { useUserDropDown };
